import { BgColorPalette } from '@/constants';
import { Text } from '@shopify/polaris';
import { memo, useMemo } from 'react';

interface ResendMailCountDownProps {
  subtractTime: number;
}

const ResendMailCountDown = ({ subtractTime }: ResendMailCountDownProps) => {
  const durationUnit = useMemo(() => {
    const seconds = Math.floor(subtractTime / 1000);
    const minutes = Math.floor(seconds / 60);

    return {
      mins: String(minutes % 60),
      secs: String(seconds % 60),
    };
  }, [subtractTime]);

  return (
    <div
      style={{
        backgroundColor: BgColorPalette.SECONDARY,
        padding: '0.15rem 0.35rem',
        borderRadius: '0.5rem',
      }}
    >
      <Text as="p" fontWeight="bold" variant="bodySm">{`${durationUnit.secs}s`}</Text>
    </div>
  );
};

export default memo(ResendMailCountDown);
